module.exports = __webpack_public_path__ + "lk.43cbeee0f9a573ac5823.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/lk.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/lk.svg
// module chunks = styles